import apiClient from '../apiClient';
import { POST_ADD_ROLE_BY_USER_ID_URL } from '../apiUrl';

const putRoleByUserIdApi = (userId, data) => {
  return apiClient.put(POST_ADD_ROLE_BY_USER_ID_URL(userId), data);
};

export default putRoleByUserIdApi;
